/** API route map: URLS.Controller.SubscriptionPlans */
export const SubscriptionPlans = {
      Name: 'SubscriptionPlans/',
      GetAll: 'getall-subscriptionplans',
      Add: 'add-subscriptionplans',
      Update: 'update-subscriptionplans',
      Delete: 'delete-subscriptionplans',
      GetSubscriptionPlanName: 'get_subscriptionName',
};
